export default __webpack_public_path__ + "static/media/client.ffac4129.jpg";